import { useSelector } from 'react-redux'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { findElementByDataId } from './utils'

export const useGenerateDraggableItems = () => {
  const modifiedActiveTimelineItemsForDragging = useSelector(
    projectDataSelectors.modifiedActiveTimelineItemsForDragging
  )

  const draggableItems = modifiedActiveTimelineItemsForDragging
    .filter(item => item !== null)
    .map(item => {
      return {
        ...item,
        node: item.id ? findElementByDataId(item.id) : null
      }
    })

  return draggableItems
}
